// Global scope for shared functions
var bundleHelpers = {};

document.addEventListener("DOMContentLoaded", function () {

    // Store variant data for each product
    const productVariantData = {};

    // Load variant data from JSON scripts
    document.querySelectorAll('[data-variant-data]').forEach(function(script) {
        const productId = script.dataset.variantData;
        try {
            productVariantData[productId] = JSON.parse(script.textContent);
        } catch (e) {
            console.error('Error parsing variant data for product:', productId, e);
        }
    });

    function updateOptionsMessage() {
        const messageEl = document.querySelector('.options_message');
        if (!messageEl) return;

        const watchList = window.specific_options_list;
        if (!watchList || !Array.isArray(watchList) || watchList.length === 0) return;

        // Normalize list values for comparison
        const normalizedList = watchList.map(v => v.trim().toLowerCase());

        let shouldShow = false;

        document.querySelectorAll('.bundle-item').forEach(function(bundleItem) {
            if (bundleItem.style.display === 'none') return;

            const productId = bundleItem.dataset.bundleProduct;
            const hiddenInput = document.querySelector(`input[data-product="${productId}"]#bundle-property-${productId}`);

            if (!hiddenInput || !hiddenInput.value) return;

            const currentValue = hiddenInput.value.trim().toLowerCase();

            if (normalizedList.includes(currentValue)) {
                shouldShow = true;
            }
        });

        messageEl.style.display = shouldShow ? 'block' : 'none';
    }


    // Get size option position from variant data
    function getSizeOptionPosition(productId) {
        const variantData = productVariantData[productId];
        if (!variantData) return null;
        
        const sizeOption = variantData.options.find(function(opt) {
            return opt.name.toLowerCase().includes('size');
        });
        
        return sizeOption ? sizeOption.position : null;
    }

    // Function to get currently selected options for a product (including global size)
    function getSelectedOptions(productId) {
        const selectedOptions = {};
        
        // Get global size selection
        const globalSizeRadio = document.querySelector('[data-global-size] input[type="radio"]:checked');
        const sizePosition = getSizeOptionPosition(productId);
        
        if (globalSizeRadio && sizePosition) {
            selectedOptions[sizePosition] = globalSizeRadio.value;
        }
        
        // Get individual product options (excluding size)
        const swatchGroups = document.querySelectorAll(`.bundle-option-swatches[data-product="${productId}"]`);
        
        swatchGroups.forEach(function(group) {
            const position = parseInt(group.dataset.optionPosition);
            const checkedRadio = group.querySelector('input[type="radio"]:checked');
            if (checkedRadio) {
                selectedOptions[position] = checkedRadio.value;
            }
        });
        
        return selectedOptions;
    }

    // Function to find variant ID based on selected options
    function findVariantId(productId, selectedOptions) {
        const variantData = productVariantData[productId];
        if (!variantData) return null;

        const matchingVariant = variantData.variants.find(function(variant) {
            return Object.keys(selectedOptions).every(function(position) {
                return variant.options[position - 1] === selectedOptions[position];
            });
        });

        return matchingVariant ? matchingVariant.id : null;
    }

    // CORE AVAILABILITY FUNCTION
    function isOptionAvailable(productId, optionPosition, optionValue) {
        const variantData = productVariantData[productId];
        if (!variantData) return true;

        const selectedOptions = getSelectedOptions(productId);
        
        return variantData.variants.some(function(variant) {
            if (!variant.available) return false;
            
            if (variant.options[optionPosition - 1] !== optionValue) return false;
            
            for (let pos in selectedOptions) {
                const posInt = parseInt(pos);
                if (posInt !== optionPosition) {
                    if (variant.options[posInt - 1] !== selectedOptions[posInt]) {
                        return false;
                    }
                }
            }
            
            return true;
        });
    }

    // Function to find first available variant for a product
    function findFirstAvailableVariant(productId) {
        const variantData = productVariantData[productId];
        if (!variantData) return null;

        const globalSizeRadio = document.querySelector('[data-global-size] input[type="radio"]:checked');
        const sizePosition = getSizeOptionPosition(productId);
        
        if (globalSizeRadio && sizePosition) {
            const globalSize = globalSizeRadio.value;
            const availableVariant = variantData.variants.find(function(variant) {
                return variant.available && variant.options[sizePosition - 1] === globalSize;
            });
            return availableVariant || null;
        }

        return variantData.variants.find(function(variant) {
            return variant.available;
        }) || null;
    }

    // Function to select options based on variant (excluding size)
    function selectVariantOptions(productId, variant) {
        if (!variant) return false;

        const swatchGroups = document.querySelectorAll(`.bundle-option-swatches[data-product="${productId}"]`);
        const sizePosition = getSizeOptionPosition(productId);
        let allSelected = true;

        swatchGroups.forEach(function(group) {
            const optionPosition = parseInt(group.dataset.optionPosition);
            
            if (optionPosition === sizePosition) return;
            
            const optionValue = variant.options[optionPosition - 1];
            
            const targetSwatch = group.querySelector(`.option-swatch[data-option-value="${CSS.escape(optionValue)}"]`);
            if (targetSwatch) {
                const radio = targetSwatch.querySelector('input[type="radio"]');
                if (radio) {
                    radio.checked = true;
                    targetSwatch.classList.add('active');
                    
                    const optionName = group.dataset.optionName;
                    const labelId = `selected-${optionName.toLowerCase().replace(/\s+/g, '-')}-${productId}`;
                    const label = document.getElementById(labelId);
                    if (label) {
                        label.textContent = optionValue;
                    }
                }
            } else {
                allSelected = false;
            }
        });

        return allSelected;
    }

    // Function to auto-select first available option for a given position
    function autoSelectFirstAvailableOption(productId, optionPosition) {
        const variantData = productVariantData[productId];
        if (!variantData) return false;
        
        const selectedOptions = getSelectedOptions(productId);
        const swatchGroup = document.querySelector(`.bundle-option-swatches[data-product="${productId}"][data-option-position="${optionPosition}"]`);
        
        if (!swatchGroup) return false;
        
        const availableVariant = variantData.variants.find(function(variant) {
            if (!variant.available) return false;
            
            for (let pos in selectedOptions) {
                const posInt = parseInt(pos);
                if (posInt !== optionPosition) {
                    if (variant.options[posInt - 1] !== selectedOptions[posInt]) {
                        return false;
                    }
                }
            }
            
            return true;
        });
        
        if (!availableVariant) return false;
        
        const targetValue = availableVariant.options[optionPosition - 1];
        const targetSwatch = swatchGroup.querySelector(`.option-swatch[data-option-value="${CSS.escape(targetValue)}"]`);
        
        if (targetSwatch) {
            const radio = targetSwatch.querySelector('input[type="radio"]');
            if (radio && !radio.checked) {
                radio.checked = true;
                
                swatchGroup.querySelectorAll('.option-swatch').forEach(el => el.classList.remove('active'));
                targetSwatch.classList.add('active');
                
                const optionName = swatchGroup.dataset.optionName;
                const labelId = `selected-${optionName.toLowerCase().replace(/\s+/g, '-')}-${productId}`;
                const label = document.getElementById(labelId);
                if (label) {
                    label.textContent = targetValue;
                }
                
                return true;
            }
        }
        
        return false;
    }

    // Function to mark product as sold out and hide all options
    function markAsSoldOut(productId) {
        const swatchGroups = document.querySelectorAll(`.bundle-option-swatches[data-product="${productId}"]`);
        swatchGroups.forEach(function(group) {
            group.classList.add('hidden');
        });

        const labels = document.querySelectorAll(`[data-option-label^="${productId}-"]`);
        labels.forEach(function(label) {
            const span = label.querySelector('.selected-option-name');
            if (span) {
                span.innerHTML = '<span class="sold-out">Sold Out</span>';
            }
        });
    }

    // Function to show all option swatches
    function showAllOptions(productId) {
        const swatchGroups = document.querySelectorAll(`.bundle-option-swatches[data-product="${productId}"]`);
        swatchGroups.forEach(function(group) {
            group.classList.remove('hidden');
        });

        const labels = document.querySelectorAll(`[data-option-label^="${productId}-"]`);
        labels.forEach(function(label) {
            label.classList.remove('hidden');
        });
    }

    // Function to update option availability states for a product
    function updateOptionAvailability(productId) {
        const swatchGroups = document.querySelectorAll(`.bundle-option-swatches[data-product="${productId}"]`);
        
        swatchGroups.forEach(function(group) {
            const optionPosition = parseInt(group.dataset.optionPosition);
            
            group.querySelectorAll('.option-swatch').forEach(function(swatch) {
                const optionValue = swatch.dataset.optionValue;
                const isAvailable = isOptionAvailable(productId, optionPosition, optionValue);
                
                if (isAvailable) {
                    swatch.classList.remove('unavailable');
                } else {
                    swatch.classList.add('unavailable');
                }
            });
        });
    }

    // Function to update global size availability for ALL bundle items
    function updateGlobalSizeAvailability() {
        const globalSizeSwatches = document.querySelectorAll('[data-global-size] .option-swatch');
        
        globalSizeSwatches.forEach(function(swatch) {
            const sizeValue = swatch.dataset.globalSizeValue;
            let isAvailable = false;
            
            document.querySelectorAll('.bundle-item').forEach(function(bundleItem) {
                if (bundleItem.style.display === 'none') return;
                
                const productId = bundleItem.dataset.bundleProduct;
                const sizePosition = getSizeOptionPosition(productId);
                
                if (sizePosition) {
                    if (isOptionAvailable(productId, sizePosition, sizeValue)) {
                        isAvailable = true;
                    }
                }
            });
            
            if (isAvailable) {
                swatch.classList.remove('unavailable');
            } else {
                swatch.classList.add('unavailable');
            }
        });
    }

    // Function to check if current selection is available
    function checkCurrentSelectionAndUpdateButton(productId) {
        const selectedOptions = getSelectedOptions(productId);
        const variantData = productVariantData[productId];
        
        if (!variantData) return true;
        
        const matchingVariant = variantData.variants.find(function(variant) {
            return Object.keys(selectedOptions).every(function(position) {
                return variant.options[position - 1] === selectedOptions[position];
            });
        });
        
        return matchingVariant ? matchingVariant.available : false;
    }

    // Function to update line item property for a product
    function updateLineItemProperty(productId) {
        const hiddenInput = document.querySelector(`input[data-product="${productId}"]#bundle-property-${productId}`);
        
        if (!hiddenInput) return;

        const selectedOptions = getSelectedOptions(productId);
        const variantData = productVariantData[productId];
        
        if (!variantData) return;
        
        let selectedValues = [];
        variantData.options.forEach(function(option) {
            const value = selectedOptions[option.position];
            if (value) {
                selectedValues.push(value);
            }
        });

        hiddenInput.value = selectedValues.join(' / ');
        
    }

    // Function to update variant image
    function updateVariantImage(productId, updateSticky = true) {
        const selectedOptions = getSelectedOptions(productId);
        const variantData = productVariantData[productId];
        if (!variantData) return;

        const matchingVariant = variantData.variants.find(function(variant) {
            return Object.keys(selectedOptions).every(function(position) {
                return variant.options[position - 1] === selectedOptions[position];
            });
        });

        // Update bundle item image
      const mainImage = document.querySelector(
        `.bundle-item-image img[data-product-image="${productId}"]`
      );

      if (mainImage) {
        let newImageSrc = null;
        let highResImageSrc = null;

        if (matchingVariant && matchingVariant.featured_image) {
          // Use 400x400 for bundle item thumbnail
          mainImage.src = matchingVariant.featured_image;
          newImageSrc = matchingVariant.featured_image;

          // Get high-res version for sticky preview (2000px width)
          highResImageSrc = matchingVariant.featured_image.replace(
            "_400x400",
            "_2000x"
          );
        } else {
          mainImage.src = mainImage.dataset.defaultImage;
          newImageSrc = mainImage.dataset.defaultImage;

          // Get high-res version of default image
          highResImageSrc = mainImage.dataset.defaultImage.replace(
            "_400x400",
            "_2000x"
          );
        }

        // Only update sticky preview if flag is true (for first item or on user interaction)
        if (updateSticky) {
          console.log(
            "Updating sticky preview with high-res:",
            highResImageSrc
          );
          updateStickyPreview(highResImageSrc);
        }
      }
    }

    function updateStickyPreview(imageSrc) {
      if (!imageSrc) {
        console.log("No image src provided to updateStickyPreview");
        return;
      }

      // Find sticky preview container
      const stickyPreview = document.querySelector(
        ".product__media[data-sticky-preview]"
      );

      if (!stickyPreview) {
        console.log("Sticky preview container not found");
        return;
      }

      console.log("Sticky preview container found");

      // Find img tag inside
      const stickyImage = stickyPreview.querySelector("img");

      if (!stickyImage) {
        console.log("Sticky preview img not found");
        return;
      }

      console.log("Updating sticky image src from:", stickyImage.src);
      console.log("To:", imageSrc);

      // Update the src with high-res image
      stickyImage.src = imageSrc;

      // Update srcset for responsive images
      if (stickyImage.hasAttribute("srcset")) {
        // Generate srcset with multiple sizes
        const baseUrl = imageSrc.split("?")[0]; // Remove query params
        const queryParams = imageSrc.includes("?")
          ? "?" + imageSrc.split("?")[1]
          : "";

        const srcsetSizes = [
          200, 300, 400, 500, 600, 700, 800, 1000, 1200, 1400, 1600, 1800, 2000,
        ];
        const srcsetArray = srcsetSizes.map((size) => {
          const sizedUrl = baseUrl.replace(/_\d+x/, `_${size}x`) + queryParams;
          return `${sizedUrl} ${size}w`;
        });

        stickyImage.srcset = srcsetArray.join(", ");
      }

      console.log("Sticky image updated successfully");
    }

    // Function to check if all bundle items have valid selections
    function checkBundleAvailability() {
        let allItemsAvailable = true;
        
        document.querySelectorAll('.bundle-item').forEach(function(bundleItem) {
            if (bundleItem.style.display === 'none') return;
            
            const productId = bundleItem.dataset.bundleProduct;
            const isAvailable = checkCurrentSelectionAndUpdateButton(productId);
            
            if (!isAvailable) {
                allItemsAvailable = false;
            }
        });
        
        return allItemsAvailable;
    }

    // Function to update add to cart button state
    function updateAddToCartButton() {
        const addToCartButton = document.querySelector('.product-form__submit');
        
        if (!addToCartButton) return;
        
        const allAvailable = checkBundleAvailability();
        const buttonTextSpan = addToCartButton.querySelector('.btn-text');
        
        if (!allAvailable) {
            addToCartButton.disabled = true;
            
            if (!addToCartButton.dataset.originalText && buttonTextSpan) {
                addToCartButton.dataset.originalText = buttonTextSpan.textContent.trim();
            }
            
            if (buttonTextSpan) {
                buttonTextSpan.textContent = 'Sold Out';
            }
            
            addToCartButton.classList.add('sold-out');
        } else {
            addToCartButton.disabled = false;
            
            if (addToCartButton.dataset.originalText && buttonTextSpan) {
                buttonTextSpan.textContent = addToCartButton.dataset.originalText;
            }
            
            addToCartButton.classList.remove('sold-out');
        }
    }

    // Get total number of options for a product
    function getTotalOptions(productId) {
        const variantData = productVariantData[productId];
        return variantData ? variantData.options.length : 0;
    }

    // Function to initialize a single bundle item
    function initializeBundleItem(productId) {
        const firstAvailableVariant = findFirstAvailableVariant(productId);
        
        if (firstAvailableVariant) {
            showAllOptions(productId);
            selectVariantOptions(productId, firstAvailableVariant);
            updateLineItemProperty(productId);
            updateVariantImage(productId);
            updateOptionAvailability(productId);
        } else {
            markAsSoldOut(productId);
        }
        updateOptionsMessage();
    }

    // INITIALIZATION
    function initializeBundle() {
        // Step 1: Find first available size
        const globalSizeGroup = document.querySelector('[data-global-size]');
        let firstAvailableSize = null;
        
        if (globalSizeGroup) {
            const firstBundleItem = document.querySelector('.bundle-item');
            if (firstBundleItem) {
                const productId = firstBundleItem.dataset.bundleProduct;
                const variantData = productVariantData[productId];
                const sizePosition = getSizeOptionPosition(productId);
                
                if (variantData && sizePosition) {
                    const sizeOption = variantData.options.find(opt => opt.position === sizePosition);
                    if (sizeOption) {
                        for (let i = 0; i < sizeOption.values.length; i++) {
                            const sizeValue = sizeOption.values[i];
                            const hasAvailableVariant = variantData.variants.some(v => 
                                v.available && v.options[sizePosition - 1] === sizeValue
                            );
                            if (hasAvailableVariant) {
                                firstAvailableSize = sizeValue;
                                break;
                            }
                        }
                    }
                }
            }
            
            if (firstAvailableSize) {
                const sizeRadios = globalSizeGroup.querySelectorAll('input[type="radio"]');
                sizeRadios.forEach(function(radio) {
                    if (radio.value === firstAvailableSize) {
                        radio.checked = true;
                        const swatch = radio.closest('.option-swatch');
                        if (swatch) {
                            swatch.classList.add('active');
                        }
                        
                        const globalLabel = document.getElementById('global-size-selected');
                        if (globalLabel) {
                            globalLabel.textContent = firstAvailableSize;
                        }
                    }
                });
            } else {
                const firstSizeRadio = globalSizeGroup.querySelector('input[type="radio"]');
                if (firstSizeRadio) {
                    firstSizeRadio.checked = true;
                    const firstSwatch = firstSizeRadio.closest('.option-swatch');
                    if (firstSwatch) {
                        firstSwatch.classList.add('active');
                    }
                    
                    const globalLabel = document.getElementById('global-size-selected');
                    if (globalLabel) {
                        globalLabel.textContent = firstSizeRadio.value;
                    }
                }
            }
        }

        // Step 2: Initialize all bundle items
        document.querySelectorAll('.bundle-item').forEach(function(bundleItem) {
            const productId = bundleItem.dataset.bundleProduct;
            initializeBundleItem(productId);
        });

        // Step 3: Update global size availability
        if (globalSizeGroup) {
            updateGlobalSizeAvailability();
        }

        // Step 4: Update add to cart button
        updateAddToCartButton();
    }

    // Run initialization
    initializeBundle();

    // Handle global size changes
    const globalSizeGroup = document.querySelector('[data-global-size]');
    if (globalSizeGroup) {
        globalSizeGroup.querySelectorAll("input[type='radio']").forEach(function (radio) {
            radio.addEventListener("change", function () {
                const swatch = radio.closest(".option-swatch");
                const selectedValue = radio.value;

                const globalLabel = document.getElementById('global-size-selected');
                if (globalLabel) {
                    globalLabel.textContent = selectedValue;
                }

                globalSizeGroup.querySelectorAll(".option-swatch").forEach(el => el.classList.remove("active"));
                swatch.classList.add("active");

                document.querySelectorAll('.bundle-item').forEach(function(bundleItem) {
                    if (bundleItem.style.display === 'none') return;
                    
                    const productId = bundleItem.dataset.bundleProduct;
                    const totalOptions = getTotalOptions(productId);
                    const sizePosition = getSizeOptionPosition(productId);
                    
                    for (let pos = 1; pos <= totalOptions; pos++) {
                        if (pos === sizePosition) continue;
                        
                        const currentSelection = getSelectedOptions(productId)[pos];
                        const isCurrentAvailable = currentSelection ? 
                            isOptionAvailable(productId, pos, currentSelection) : false;
                        
                        if (!isCurrentAvailable) {
                            autoSelectFirstAvailableOption(productId, pos);
                        }
                    }
                    
                    updateOptionAvailability(productId);
                    updateVariantImage(productId);
                    updateLineItemProperty(productId);
                });
                
                updateAddToCartButton();
                updateOptionsMessage(); 

            });
        });
    }

    // Handle individual option changes
    document.querySelectorAll(".bundle-option-swatches[data-product]").forEach(function (group) {
        const productId = group.dataset.product;
        const optionName = group.dataset.optionName;
        const optionPosition = parseInt(group.dataset.optionPosition);
        const totalOptions = getTotalOptions(productId);

        group.querySelectorAll("input[type='radio']").forEach(function (radio) {
            radio.addEventListener("change", function () {

                const swatch = radio.closest(".option-swatch");
                const selectedValue = radio.value;

                const labelId = `selected-${optionName.toLowerCase().replace(/\s+/g, '-')}-${productId}`;
                const label = document.getElementById(labelId);
                if (label) {
                    label.textContent = selectedValue;
                }

                group.querySelectorAll(".option-swatch").forEach(el => el.classList.remove("active"));
                swatch.classList.add("active");

                const sizePosition = getSizeOptionPosition(productId);
                for (let pos = 1; pos <= totalOptions; pos++) {
                    if (pos === optionPosition || pos === sizePosition) continue;
                    
                    const currentSelection = getSelectedOptions(productId)[pos];
                    const isCurrentAvailable = currentSelection ? 
                        isOptionAvailable(productId, pos, currentSelection) : false;
                    
                    if (!isCurrentAvailable) {
                        autoSelectFirstAvailableOption(productId, pos);
                    }
                }

                updateOptionAvailability(productId);
                updateGlobalSizeAvailability();
                updateVariantImage(productId);
                updateLineItemProperty(productId);
                updateAddToCartButton();
                updateOptionsMessage();
            });
        });

    });

    // Expose functions to global scope for Pack size handler
    bundleHelpers.initializeBundleItem = initializeBundleItem;
    bundleHelpers.updateGlobalSizeAvailability = updateGlobalSizeAvailability;
    bundleHelpers.updateAddToCartButton = updateAddToCartButton;

});

// Watch for Pack size changes
(function() {
    function updateBundleItemsVisibility() {
        const checkedPackRadio = document.querySelector('input[type="radio"][name^="Pack"]:checked');
        if (!checkedPackRadio) return;

        // hide thumbnail if bundle option value is 1
        const bundleImages = document.querySelectorAll('.bundle-item-image');

        if (checkedPackRadio.value == "1") {
            bundleImages.forEach(el => {
                el.style.display = "none";
            });
        } else {
            bundleImages.forEach(el => {
                el.style.display = "block";
            });
        }
        
        const newPackSize = parseInt(checkedPackRadio.value);
        if (isNaN(newPackSize)) return;
        
        const allBundleItems = document.querySelectorAll('.bundle-item');
        
        allBundleItems.forEach(function(item, index) {
            const unitNumber = index + 1;
            const hiddenInputs = item.querySelectorAll('input[type="hidden"]');
            const wasHidden = item.style.display === 'none';
            
            if (unitNumber <= newPackSize) {
                item.style.display = '';
                hiddenInputs.forEach(function(input) {
                    if (input.dataset.originalName) {
                        input.name = input.dataset.originalName;
                    }
                });
                
                // If this item was just made visible, initialize it
                if (wasHidden && bundleHelpers.initializeBundleItem) {
                    const productId = item.dataset.bundleProduct;
                    bundleHelpers.initializeBundleItem(productId);
                }
            } else {
                item.style.display = 'none';
                hiddenInputs.forEach(function(input) {
                    if (!input.dataset.originalName) {
                        input.dataset.originalName = input.name;
                    }
                    input.name = '';
                });
            }
        });
        
        if (bundleHelpers.updateGlobalSizeAvailability) {
            bundleHelpers.updateGlobalSizeAvailability();
        }
        
        if (bundleHelpers.updateAddToCartButton) {
            bundleHelpers.updateAddToCartButton();
        }
    }

    document.addEventListener('change', function(e) {
        if (e.target.type === 'radio' && e.target.name && e.target.name.startsWith('Pack')) {
            updateBundleItemsVisibility();
        }
    });
    
    const observer = new MutationObserver(function() {
        updateBundleItemsVisibility();
    });
    
    const variantSelects = document.querySelector('variant-selects');
    if (variantSelects) {
        observer.observe(variantSelects, {
            childList: true,
            subtree: true
        });
    }
    
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', updateBundleItemsVisibility);
    } else {
        updateBundleItemsVisibility();
    }
})();